import { usePaymentProviders } from 'api/queries';
import { getInitialStoreName } from 'config/client';
import { usePaymentsEnabled } from 'stores/appStore';

export function usePaymentConnectionState() {
  const isPaymentConsentStepIncluded = !getInitialStoreName();
  const paymentsEnabled = usePaymentsEnabled();
  const { data: paymentData, isLoading } = usePaymentProviders({ enabled: isPaymentConsentStepIncluded });
  const isPaymentProviderAvailable = paymentData?.isAvailable ?? false;

  return {
    isLoading,
    isPaymentProviderAvailable,
    paymentsEnabled,
    shouldConnectPayments: isPaymentConsentStepIncluded && paymentsEnabled && isPaymentProviderAvailable,
  };
}
